import { IconComponentsProps } from './types';

const DatasetReadyForReview = ({ fill = '#59A719', ...props }: IconComponentsProps) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M27.1837 3.88281C27.6986 3.88289 28.1927 4.08808 28.5568 4.45215C28.9207 4.81625 29.1251 5.3104 29.1251 5.8252V15.5332H27.1837V5.8252H3.88293V25.2412H15.5333V27.1836H3.88293C3.36812 27.1835 2.87393 26.9783 2.50989 26.6143C2.14597 26.2502 1.94153 25.756 1.94153 25.2412V5.8252C1.94153 5.31043 2.14602 4.81624 2.50989 4.45215C2.87393 4.08811 3.36812 3.88292 3.88293 3.88281H27.1837ZM25.1564 20.0986L29.1251 20.6758L26.213 23.2998L26.9611 27.1836L23.2999 24.999L19.6388 27.1836L20.3878 23.2998L17.4747 20.6758L21.5529 20.0986L23.2999 16.5039L25.1564 20.0986ZM11.6505 17.4746H5.82532V15.5332H11.6505V17.4746ZM15.5333 13.5918H5.82532V11.6494H15.5333V13.5918ZM15.5333 9.70801H5.82532V7.7666H15.5333V9.70801Z"
      fill={fill}
    />
  </svg>
);

export default DatasetReadyForReview;
